import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ILocationFormMeta {
    address: FormInputMeta;
    street: FormInputMeta;
    state: FormInputMeta;
    code: FormInputMeta;
    poBox: FormInputMeta;
    city: FormInputMeta;
    country: FormInputMeta;

}

const locationFormMeta = {} as ILocationFormMeta;

locationFormMeta.address = {
    name: "address",
    type: "textarea",
    label: "Adresse",
    placeholder: "",
    validation: yup.string()
};

locationFormMeta.street = {
    name: "street",
    type: "text",
    label: "Rue",
    placeholder: "Rue",
    validation: yup.string()
};

locationFormMeta.state = {
    name: "state",
    type: "text",
    label: "Etat",
    placeholder: "Etat",
    validation: yup.string()
};

locationFormMeta.code = {
    name: "code",
    type: "text",
    label: "Code",
    placeholder: "Code",
    validation: yup.string()
};

locationFormMeta.poBox = {
    name: "poBox",
    type: "text",
    label: "Po Box",
    placeholder: "Po Box",
    validation: yup.string()
};

locationFormMeta.city = {
    name: "city",
    type: "select",
    label: "Ville",
    validation: yup.string()
};

locationFormMeta.country = {
    name: "country",
    type: "text",
    label: "Pays",
    placeholder: "Pays",
    validation: yup.string()
};

export default locationFormMeta;